export const PROGRESS_START_MUTATION = "PROGRESS_START_MUTATION";
export const PROGRESS_END_MUTATION = "PROGRESS_END_MUTATION";
